import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  navHeight: 80,
  sectionPadding: "padding-top: 1.5em; padding-bottom: 1.5em;",
  fonts: {
    primary: "Inter, sans-serif",
    secondary: "Tinos, sans-serif",
  },
  layout: {
    contentWidth: 1236,
  },
  palette: {
    primary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#2E558A",
      light: "#FFFFFF",
      dark: "#091118",
    },
    secondary: {
      // contrastText: "rgba(0, 0, 0, 0.87)",
      main: "#E9BB53",
      light: "#909098",
      dark: "#1F1D2F",
    },
    tertiary: {
      main: "#2C9ED0",
      dark: "#0D1827",
    },
    text: {
      primary: "#2E558A",
      secondary: "#909098",
      content: "#0D1827",
      tertiary: "#1A2933",
      disabled: "#10355A",
      hint: "#10355A",
      light: "#FFFFFF",
    },
    alternate: {
      main: "rgb(247, 249, 250)",
      dark: "#e8eaf6",
    },
  },
  typography: {
    fontFamily: `"Inter","Tinos","DM Sans", "Open Sans", "Arial", sans-serif`,
  },
})

export default theme
